

<div class="login-area">
  <div class="row m-0">
      <div class="col-lg-12 col-md-12 p-0">

        <router-outlet></router-outlet>

      </div>
  </div>
</div> 